import LRU from 'lru-cache';
import { debug } from '@/constants/Constants';
import cacheManager from '@/api/middlewares/cache-manager';

class CancelManager extends LRU {
  abort(key) {
    if (this.get(key) && this.get(key).abort) {
      this.get(key).abort();
      this.del(key);
    }
  }
}

const cancelManager = new CancelManager({
  max: 500,
  maxAge: 1000 * 60,
});

if (debug) {
  window.__cacelManager__ = cacheManager;
}

export default cancelManager;
